import api from "./api";

export interface IAsignacionDetalle {
    asig_cab_id: number;
    dom_ent: string | null;
    dom_sal: string | null;
    estado: string;
    fecha_inicio: string;
    id: number;
    jue_ent: string;
    jue_sal: string;
    lun_ent: string;
    lun_sal: string;
    mar_ent: string;
    mar_sal: string;
    mie_ent: string;
    mie_sal: string;
    operario_ci: string;
    operario_id: number;
    ps_id: number;
    sab_ent: string;
    sab_sal: string;
    total_horas: string;
    vie_ent: string;
    vie_sal: string;
}

export const fetchAsignacionDetalle = async (ps_id: number, asig_id: number): Promise<IAsignacionDetalle> => {
    try {
        const response = await api.get(`/asignacion/asignaciones_detalle/${ps_id}?asig_id=${asig_id}`);

        const data = await response.data.datos;

        if (!data) {
            throw new Error('Unexpected response format');
        }

        return data;
    } catch (error) {
        console.error('Error al obtener el detalle de la asignación:', error);
        throw error;
    }
}

